<!-- eslint-disable vue/html-self-closing -->
<template>
  <div class="commit-list d-flex flex-column">
    <div
      class="day-commit flex-column py-2"
      v-for="(commitGroup, date) in commitGroups.commits"
      :key="commitGroup.key"
    >
      <div class="d-flex align-items-center mb-2 commit-date d-flex align-items-center">
        <i class="gf-icon gf-icon-dot text-secondary"></i>
        <h6 class="mb-0">{{ date }}</h6>
      </div>
      <div class="d-flex">
        <ul class="d-flex flex-column w-100 gap-3">
          <li
            class="d-flex px-3 py-2 align-items-center border rounded gap-2"
            v-for="commit in commitGroup"
            :key="commit.hash"
          >
            <commit-list-item
              :commit="commit"
              :has-reactive-links="hasReactiveLinks"
              :can-create-tag="canCreateTag"
              :can-start-container="canStartContainer"
              @revert="onRevert"
            />
          </li>
        </ul>
      </div>
    </div>
    <empty-listing
      v-if="commitGroups?.commits && !Object.keys(commitGroups?.commits).length"
      :title="$tc('message.commit', 3)"
    />
    <gf-custom-short-pagination
      v-if="
        showPagination && commitGroups?.commits && Object.keys(commitGroups?.commits).length > 0
      "
      :has-next="commitGroups?.hasNext"
      @change="paginate"
    ></gf-custom-short-pagination>
  </div>
</template>

<script>
import EmptyListing from '@shared/shared-components/empty-listing';
import GfCopyCommitHash from '../shared/GfCopyCommitHash.vue';
import GfCustomModalWindow from '@shared/shared-components/shared/GfCustomModalWindow';
import GfCustomShortPagination from '@shared/shared-components/shared/GfCustomShortPagination';
import CommitMessages from '@/shared-modules/modules/commit/commit.messages';
import CommitListItem from '@/shared-modules/shared-components/commit/commit-list-item.vue';

export default {
  name: 'commit-list',
  components: {
    EmptyListing,
    GfCopyCommitHash,
    GfCustomModalWindow,
    GfCustomShortPagination,
    CommitListItem
  },
  props: {
    commitGroups: null,
    canCreateTag: {
      type: Boolean,
      default: false
    },
    canStartContainer: {
      type: Boolean,
      default: false
    },
    hasReactiveLinks: {
      type: Boolean,
      default: true
    },
    showPagination: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    paginate(page) {
      this.$router.push({ query: { ...this.$route.query, page } });
    },
    onRevert() {
      this.$emit('revert');
    }
  },
  i18n: {
    messages: CommitMessages
  }
};
</script>
